import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CATEGORY, PLATFORM } from '../../../constants';
import { VM_WARE_PRODUCT } from './constants';
export var VM_WARE_CATALOG = _defineProperty({}, PLATFORM.VmWare, [{
  id: CATEGORY.Popular,
  label: 'Популярное',
  dataTestId: 'popular',
  visibleProducts: [VM_WARE_PRODUCT.VmWareVirtualDataCenter, VM_WARE_PRODUCT.VmWareCloudBackup, VM_WARE_PRODUCT.VmWareVirtualMachinesBackup, VM_WARE_PRODUCT.VmWareVirtualWorkspaces]
}]);